import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ConnectivityService } from '@app/core/connectivity/connectivity.service';

@Component({
  selector: 'app-connection-status',
  templateUrl: './connection-status.html',
  styleUrl: './connection-status.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.data-visible]': '!isOnline() || null',
  },
})
export class ConnectionStatus {
  protected readonly isOnline = inject(ConnectivityService).isOnline;
}
